module.exports = __webpack_public_path__ + "img/thomas-cary.366deadd.png";